(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6332],{

/***/ 72697:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schedule",
      function () {
        return __webpack_require__(31083);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ui_typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58020);



var PageHeadingSection = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex-col justify-start items-start gap-4 inline-flex",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-sky-950 text-[32px] font-bold leading-10",
                children: props.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "self-stretch text-sky-950 text-[14px] font-normal leading-normal",
                children: props.subtitle
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col justify-center align-center gap-6",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
                variant: "h1",
                className: "text-center",
                asChild: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
                variant: "h4",
                className: "text-center"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeadingSection);


/***/ }),

/***/ 11340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SigninConditionalRenderer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./util/auth.tsx + 1 modules
var util_auth = __webpack_require__(19475);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./lib/utils.ts + 11 modules
var utils = __webpack_require__(74183);
// EXTERNAL MODULE: ./components/ui/typography.tsx
var typography = __webpack_require__(58020);
// EXTERNAL MODULE: ./components/ui/button.tsx
var ui_button = __webpack_require__(35739);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/DummyBox.tsx






var DummyBox = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,utils.cn)("py-4 px-6 backdrop-blur-[4px] bg-white flex items-center justify-center flex-col gap-4", props.className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: "h5",
                        className: "text-center",
                        children: props.title
                    }) : null,
                    props.subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: "p",
                        className: "text-center",
                        children: props.subtitle
                    }) : null
                ]
            }),
            props.buttonText && props.buttonPath ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                passHref: true,
                href: props.buttonPath,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                    variant: "secondary",
                    size: "sm",
                    asChild: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: props.buttonText
                    })
                })
            }) : null
        ]
    });
};
/* harmony default export */ var components_DummyBox = (DummyBox);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./components/SigninConditionalRenderer.tsx







var SigninConditionalRenderer = function(param) {
    var buttonText = param.buttonText, children = param.children, _mode = param.mode, mode = _mode === void 0 ? "replace" : _mode, title = param.title, _authRequired = param.authRequired, authRequired = _authRequired === void 0 ? true : _authRequired;
    var auth = (0,util_auth/* useAuth */.aC)();
    var router = (0,next_router.useRouter)();
    if (auth.isAuthenticated || !authRequired) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        });
    }
    if (mode === "replace") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DummyBox, {
            className: "my-4",
            title: title,
            buttonText: buttonText,
            buttonPath: "/auth/signin?next=".concat(encodeURIComponent(router.asPath))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("relative group", (0,_define_property/* default */.Z)({}, "overflow-hidden hover:", mode === "overlay")),
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DummyBox, {
                className: (0,clsx_m/* default */.Z)("absolute inset-0 z-10 group:hover:opacity-1 group-hover:pointer-events-auto", (0,_define_property/* default */.Z)({}, "pointer-events-none opacity-0 absolute transition-opacity duration-300 inset-0", mode === "overlay")),
                title: title,
                buttonText: buttonText,
                buttonPath: "/auth/signin?next=".concat(encodeURIComponent(router.asPath))
            })
        ]
    });
};
/* harmony default export */ var components_SigninConditionalRenderer = (SigninConditionalRenderer);


/***/ }),

/***/ 70499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$N": function() { return /* binding */ DialogTitle; },
/* harmony export */   "Be": function() { return /* binding */ DialogDescription; },
/* harmony export */   "GG": function() { return /* binding */ DialogClose; },
/* harmony export */   "Vq": function() { return /* binding */ Dialog; },
/* harmony export */   "cN": function() { return /* binding */ DialogFooter; },
/* harmony export */   "cZ": function() { return /* binding */ DialogContent; },
/* harmony export */   "fK": function() { return /* binding */ DialogHeader; },
/* harmony export */   "hg": function() { return /* binding */ DialogTrigger; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12854);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41352);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74183);
"use client";








var Dialog = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC;
var DialogTrigger = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Trigger */ .xz;
var DialogClose = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8;
var DialogPortal = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Portal */ .h_, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)(className)
    }, props));
};
DialogPortal.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Portal.displayName */ .h_.displayName;
var DialogOverlay = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Overlay */ .aV, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("fixed inset-0 z-50 bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className)
    }, props));
});
DialogOverlay.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Overlay.displayName */ .aV.displayName;
var DialogContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DialogPortal, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogOverlay, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Content */ .VY, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                ref: ref,
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg md:w-full", className)
            }, props), {
                children: [
                    children,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8, {
                        className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "sr-only",
                                children: "Close"
                            })
                        ]
                    })
                ]
            }))
        ]
    });
});
DialogContent.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Content.displayName */ .VY.displayName;
var DialogHeader = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("flex flex-col space-y-1.5 text-center sm:text-left", className)
    }, props));
};
DialogHeader.displayName = "DialogHeader";
var DialogFooter = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className)
    }, props));
};
DialogFooter.displayName = "DialogFooter";
var DialogTitle = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("text-lg font-semibold leading-none tracking-tight", className)
    }, props));
});
DialogTitle.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Title.displayName */ .Dx.displayName;
var DialogDescription = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Description */ .dk, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("text-sm text-muted-foreground", className)
    }, props));
});
DialogDescription.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Description.displayName */ .dk.displayName;



/***/ }),

/***/ 58020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Typography; }
/* harmony export */ });
/* unused harmony export typographyVariants */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var class_variance_authority__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12003);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88426);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74183);







var typographyVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_2__/* .cva */ .j)("", {
    variants: {
        variant: {
            default: "",
            h1: "scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl",
            h2: "scroll-m-20 pb-2 text-3xl font-semibold tracking-tight transition-colors first:mt-0",
            h3: "scroll-m-20 text-2xl font-semibold tracking-tight",
            h4: "scroll-m-20 text-xl font-semibold tracking-tight",
            h5: "scroll-m-20 text-lg font-semibold tracking-tight",
            h6: "scroll-m-20 text-sm font-semibold tracking-tight",
            p: "leading-7 [&:not(:first-child)]:mt-6",
            blockquote: "mt-6 border-l-2 pl-6 italic",
            lead: "text-xl text-muted-foreground",
            large: "text-lg font-semibold",
            small: "text-sm font-medium leading-none",
            muted: "text-xs text-muted-foreground",
            xs: "text-xs font-medium leading-none"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
var Typography = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, variant = _param.variant, _asChild = _param.asChild, asChild = _asChild === void 0 ? false : _asChild, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "variant",
        "asChild"
    ]);
    var Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_4__/* .Slot */ .g7 : "p";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_6__.cn)(typographyVariants({
            variant: variant,
            className: className
        })),
        ref: ref
    }, props));
});
Typography.displayName = "Typography";



/***/ }),

/***/ 31083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ schedule; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/PageHeadingSection.tsx
var PageHeadingSection = __webpack_require__(29016);
// EXTERNAL MODULE: ./util/format.ts + 9 modules
var format = __webpack_require__(16685);
// EXTERNAL MODULE: ./components/cards/CaseCardHorizontal.tsx
var CaseCardHorizontal = __webpack_require__(54297);
// EXTERNAL MODULE: ./util/auth.tsx + 1 modules
var util_auth = __webpack_require__(19475);
// EXTERNAL MODULE: ./util/time.js
var time = __webpack_require__(91040);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(46035);
// EXTERNAL MODULE: ./features/casesSlice.ts
var casesSlice = __webpack_require__(94916);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(1438);
// EXTERNAL MODULE: ./components/Case/CaseParticipantsModal.tsx
var CaseParticipantsModal = __webpack_require__(82698);
// EXTERNAL MODULE: ./components/SeoTags.tsx
var SeoTags = __webpack_require__(47460);
// EXTERNAL MODULE: ./features/timezoneSlice.js
var timezoneSlice = __webpack_require__(70118);
// EXTERNAL MODULE: ./components/AddCaseToCalendarLink.tsx
var AddCaseToCalendarLink = __webpack_require__(2902);
// EXTERNAL MODULE: ./util/cases.js
var cases = __webpack_require__(65105);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/ui/button.tsx
var ui_button = __webpack_require__(35739);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/calendar-plus.js
var calendar_plus = __webpack_require__(57672);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/arrow-up-right.js
var arrow_up_right = __webpack_require__(62112);
;// CONCATENATED MODULE: ./components/UserCasesList.tsx













var myScheduledCasesSelector = (0,casesSlice/* makeGetCaseByStatus */.uU)({
    selectedStatus: [
        constants/* CaseStatuses.SCHEDULED */.HM.SCHEDULED,
        constants/* CaseStatuses.TENTATIVE */.HM.TENTATIVE
    ],
    sortKey: "scheduled_to",
    userParticipantFilter: true
});
var UserCasesList = function(param) {
    var _showCount = param.showCount, showCount = _showCount === void 0 ? 5 : _showCount;
    var auth = (0,util_auth/* useAuth */.aC)();
    var myCases = (0,es/* useSelector */.v9)(function(state) {
        var now = Date.now() / 1000;
        return myScheduledCasesSelector(state).filter(function(it) {
            var diff = it.scheduled_to - now;
            var hourInMilliseconds = 3600000;
            if (diff > 0) {
                return true;
            }
            return Math.abs(diff) < 2 * hourInMilliseconds;
        });
    });
    if (!auth.isAuthenticated) {
        return null;
    }
    if (!myCases || !myCases.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col items-start gap-2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "font-semibold text-sm",
                children: "You have not registered for any session yet."
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col gap-6",
        children: (myCases || []).slice(0, showCount).map(function(it) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserCasesListItem, {
                caseId: it.id
            }, it.id);
        })
    });
};
var UserCasesListItem = function(param) {
    var caseId = param.caseId;
    var currentCase = (0,es/* useSelector */.v9)(function(state) {
        return (0,casesSlice/* selectCaseById */.pJ)(state, caseId);
    });
    var timezone = (0,es/* useSelector */.v9)(timezoneSlice/* selectTimezone */.pE);
    var handleAddToCalendar = (0,AddCaseToCalendarLink/* useAddToCalendar */.U)(caseId);
    if (!currentCase) {
        return null;
    }
    var isPlaceholder = currentCase.state === constants/* CaseStatuses.TENTATIVE */.HM.TENTATIVE;
    var showJoinButton = (0,cases/* shouldShowJoinCaseButton */.rC)(currentCase);
    var timeToStart = currentCase.scheduled_to - Date.now() / 1000;
    var isStartingSoon = timeToStart < 600;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-start gap-2",
        children: [
            isStartingSoon && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-xs text-teal-200",
                children: (0,format/* getTimeToStart */.mu)(timeToStart)
            }),
            !isStartingSoon && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-xs text-muted-foreground",
                children: (0,format/* formatDate */.p6)({
                    ts: currentCase.scheduled_to,
                    format: "long",
                    tz: timezone
                })
            }),
            isPlaceholder ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "font-semibold text-sm",
                children: currentCase.title
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: !isPlaceholder ? "/case/".concat(caseId) : "#",
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "font-semibold text-sm",
                    children: currentCase.title
                })
            }),
            !showJoinButton ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                variant: "link",
                onClick: handleAddToCalendar,
                className: "text-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(calendar_plus/* default */.Z, {
                        className: "w-4 h-4"
                    }),
                    " Add to calendar"
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                variant: "link",
                className: "text-sm",
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: currentCase.zoom_us_link,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_up_right/* default */.Z, {
                            className: "w-4 h-4"
                        }),
                        " Join the session"
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_UserCasesList = (UserCasesList);

// EXTERNAL MODULE: ./node_modules/lodash/partition.js
var partition = __webpack_require__(43174);
var partition_default = /*#__PURE__*/__webpack_require__.n(partition);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/SigninConditionalRenderer.tsx + 1 modules
var SigninConditionalRenderer = __webpack_require__(11340);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/chevron-left.js
var chevron_left = __webpack_require__(98814);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/chevron-right.js
var chevron_right = __webpack_require__(64998);
// EXTERNAL MODULE: ./node_modules/react-day-picker/dist/index.esm.js + 33 modules
var index_esm = __webpack_require__(27474);
// EXTERNAL MODULE: ./lib/utils.ts + 11 modules
var utils = __webpack_require__(74183);
;// CONCATENATED MODULE: ./components/ui/calendar.tsx
"use client";









function Calendar(_param) {
    var className = _param.className, classNames = _param.classNames, _showOutsideDays = _param.showOutsideDays, showOutsideDays = _showOutsideDays === void 0 ? true : _showOutsideDays, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "classNames",
        "showOutsideDays"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* DayPicker */._W, (0,_object_spread/* default */.Z)({
        showOutsideDays: showOutsideDays,
        className: (0,utils.cn)("p-3", className),
        classNames: (0,_object_spread/* default */.Z)({
            months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
            month: "space-y-4",
            caption: "flex justify-center pt-1 relative items-center",
            caption_label: "text-sm font-medium",
            nav: "space-x-1 flex items-center",
            nav_button: (0,utils.cn)((0,ui_button/* buttonVariants */.d)({
                variant: "outline"
            }), "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"),
            nav_button_previous: "absolute left-1",
            nav_button_next: "absolute right-1",
            table: "w-full border-collapse space-y-1",
            head_row: "flex",
            head_cell: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
            row: "flex w-full mt-2",
            cell: "text-center text-sm p-0 relative [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
            day: (0,utils.cn)((0,ui_button/* buttonVariants */.d)({
                variant: "ghost"
            }), "h-9 w-9 p-0 font-normal aria-selected:opacity-100"),
            day_selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
            day_today: "bg-accent text-accent-foreground",
            day_outside: "text-muted-foreground opacity-50",
            day_disabled: "text-muted-foreground opacity-50",
            day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
            day_hidden: "invisible"
        }, classNames),
        components: {
            IconLeft: function(_param) /*#__PURE__*/ {
                var props = (0,_extends/* default */.Z)({}, _param);
                return (0,jsx_runtime.jsx)(chevron_left/* default */.Z, {
                    className: "h-4 w-4"
                });
            },
            IconRight: function(_param) /*#__PURE__*/ {
                var props = (0,_extends/* default */.Z)({}, _param);
                return (0,jsx_runtime.jsx)(chevron_right/* default */.Z, {
                    className: "h-4 w-4"
                });
            }
        }
    }, props));
}
Calendar.displayName = "Calendar";


// EXTERNAL MODULE: ./node_modules/@radix-ui/react-hover-card/dist/index.mjs
var dist = __webpack_require__(40);
;// CONCATENATED MODULE: ./components/ui/hover-card.tsx
"use client";






var HoverCard = dist/* Root */.fC;
var HoverCardTrigger = dist/* Trigger */.xz;
var HoverCardContent = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, _align = _param.align, align = _align === void 0 ? "center" : _align, _sideOffset = _param.sideOffset, sideOffset = _sideOffset === void 0 ? 4 : _sideOffset, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "align",
        "sideOffset"
    ]);
    return (0,jsx_runtime.jsx)(dist/* Content */.VY, (0,_object_spread/* default */.Z)({
        ref: ref,
        align: align,
        sideOffset: sideOffset,
        className: (0,utils.cn)("z-50 w-64 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className)
    }, props));
});
HoverCardContent.displayName = dist/* Content.displayName */.VY.displayName;


// EXTERNAL MODULE: ./components/ui/typography.tsx
var typography = __webpack_require__(58020);
// EXTERNAL MODULE: ./components/UserAvatar.tsx
var UserAvatar = __webpack_require__(8222);
// EXTERNAL MODULE: ./features/usersSlice.js
var usersSlice = __webpack_require__(97219);
;// CONCATENATED MODULE: ./pages/schedule.tsx




























var scheduledCasesSelector = (0,casesSlice/* makeGetCaseByStatus */.uU)({
    selectedStatus: [
        constants/* CaseStatuses.SCHEDULED */.HM.SCHEDULED,
        constants/* CaseStatuses.TENTATIVE */.HM.TENTATIVE
    ],
    sortKey: "scheduled_to",
    userParticipantFilter: undefined
});
function ScheduledCases(props) {
    var _content = props.content, content = _content === void 0 ? {} : _content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoTags/* default */.Z, {
                config: content.seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-12 sm:gap-x-8 gap-y-6 mt-8 mb-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-span-12 lg:col-span-10 lg:col-start-3 flex flex-col pb-6 mb-6 gap-6 border-b-[1px] border-b-gray-200",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeadingSection/* default */.Z, {
                                    backgroundImage: content.heading_background,
                                    title: content.heading_title,
                                    subtitle: content.heading_subtitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarsList, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-12 lg:col-start-3 lg:col-span-7 flex flex-col gap-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CasesList, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-12 lg:col-span-3 relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sticky top-[100px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        variant: "h5",
                                        className: "mb-4",
                                        children: "My sessions"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SigninConditionalRenderer/* default */.Z, {
                                        title: "You must be logged in to access this content",
                                        buttonText: "Log in to continue",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserCasesList, {
                                            showCount: 3,
                                            fallbackProps: undefined
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var CaseInTooltip = function(param) {
    var caseItem = param.caseItem;
    var timezone = (0,es/* useSelector */.v9)(timezoneSlice/* selectTimezone */.pE);
    var timeToStart = caseItem.scheduled_to - Date.now() / 1000;
    var isStartingSoon = timeToStart < 600;
    var isPlaceholder = caseItem.state === constants/* CaseStatuses.TENTATIVE */.HM.TENTATIVE;
    var userId = caseItem === null || caseItem === void 0 ? void 0 : caseItem.user;
    var user = (0,es/* useSelector */.v9)(function(state) {
        return userId ? (0,usersSlice/* selectUserById */.Ls)(state, userId) : null;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-start gap-2 pb-2 mb-2 border-b-[1px] border-b-gray-200",
                children: [
                    isStartingSoon && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xs text-teal-200",
                        children: (0,format/* getTimeToStart */.mu)(timeToStart)
                    }),
                    !isStartingSoon && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xs text-muted-foreground",
                        children: (0,format/* formatDate */.p6)({
                            ts: caseItem.scheduled_to,
                            format: "long",
                            tz: timezone
                        })
                    }),
                    isPlaceholder ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-semibold text-sm text-left",
                        children: caseItem.title
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: !isPlaceholder ? "/case/".concat(caseItem.id) : "#",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "font-semibold text-sm text-left",
                            children: caseItem.title
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* UserAvatar */.Y, {
                        userId: userId
                    }),
                    !!user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm font-medium leading-none",
                                children: (0,format/* formatName */.KY)(user)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-muted-foreground",
                                children: user.position
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
function DayWithTooltip(props) {
    var currentCases = (0,es/* useSelector */.v9)(scheduledCasesSelector);
    var ref = (0,_sliced_to_array/* default */.Z)(partition_default()(currentCases.filter(function(it) {
        return it.scheduled_to;
    }), function(it) {
        return it.user_participant;
    }), 2), myCases = ref[0], otherCases = ref[1];
    var matchedCases = (0,_to_consumable_array/* default */.Z)(myCases).concat((0,_to_consumable_array/* default */.Z)(otherCases)).filter(function(it) {
        return (0,time/* isSameDay */.KC)(props.date, new Date(it.scheduled_to * 1000));
    });
    if (!matchedCases.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Day */.Jc, (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard, {
        openDelay: 300,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCardTrigger, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Day */.Jc, (0,_object_spread/* default */.Z)({}, props))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCardContent, {
                className: "w-80",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col gap-4",
                    children: matchedCases.map(function(it, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseInTooltip, {
                                caseItem: it
                            })
                        }, it.id);
                    })
                })
            })
        ]
    });
}
var CalendarsList = function() {
    var currentCases = (0,es/* useSelector */.v9)(scheduledCasesSelector);
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)(partition_default()(currentCases.filter(function(it) {
        return it.scheduled_to;
    }), function(it) {
        return it.user_participant;
    }), 2), myCases = ref[0], otherCases = ref[1];
    var calendarsCount = 3;
    var nextMonthDates = Array(calendarsCount).fill(undefined).reduce(function(acc, _, index) {
        acc.push(index === 0 ? new Date() : (0,time/* getNextMonthDate */.rh)(acc[index - 1]));
        return acc;
    }, []);
    var mySessionsDates = myCases.map(function(it) {
        return new Date(it.scheduled_to * 1000);
    });
    var availableSessionsDates = otherCases.map(function(it) {
        return new Date(it.scheduled_to * 1000);
    });
    var thisDay = new Date();
    thisDay.setHours(0, 0, 0, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-wrap lg:flex-nowrap gap-6",
        children: nextMonthDates.map(function(it, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar, {
                className: (0,utils.cn)("bg-white hidden rounded-lg border-0 shadow-lg 2xl:w-1/3 items-center justify-center", {
                    "flex": index === 0,
                    "lg:flex": index === 1,
                    "xl:flex": index === 2
                }),
                classNames: {
                    months: "flex flex-col space-y-4 sm:space-x-4 sm:space-y-0",
                    day_today: "",
                    nav_button_previous: "hidden",
                    nav_button_next: "hidden",
                    caption: "flex pt-1 pb-2 mx-2 border-b-[1px] border-b-muted relative items-center"
                },
                mode: "multiple",
                initialFocus: true,
                numberOfMonths: 1,
                defaultMonth: it,
                selected: [],
                components: {
                    Day: DayWithTooltip
                },
                disabled: [
                    {
                        before: thisDay
                    }
                ],
                modifiers: {
                    booked: mySessionsDates,
                    events: availableSessionsDates
                },
                modifiersClassNames: {
                    booked: "bg-accent text-accent-foreground",
                    events: "bg-accent text-accent-foreground"
                },
                onSelect: function(selected) {
                    var selectedDay = selected[0];
                    if (!selectedDay) {
                        return;
                    }
                    var matchedCase = (0,_to_consumable_array/* default */.Z)(myCases).concat((0,_to_consumable_array/* default */.Z)(otherCases)).find(function(it) {
                        return (0,time/* isSameDay */.KC)(selectedDay, new Date(it.scheduled_to * 1000));
                    });
                    if (!matchedCase) {
                        return;
                    }
                    router.push({
                        pathname: "/case/".concat(matchedCase.id)
                    });
                }
            }, index);
        })
    });
};
var CasesList = function() {
    var ref = (0,react.useState)(null), currentCaseId = ref[0], setCurrentCaseId = ref[1];
    var cases = (0,es/* useSelector */.v9)(scheduledCasesSelector);
    var auth = (0,util_auth/* useAuth */.aC)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            cases.map(function(param) {
                var id = param.id;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseCardHorizontal/* default */.Z, {
                    onParticipantsClick: auth.isAuthenticated ? function() {
                        return setCurrentCaseId(id);
                    } : undefined,
                    caseId: id
                }, id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseParticipantsModal/* default */.Z, {
                caseId: currentCaseId,
                open: !!currentCaseId,
                onOpenChange: function(isOpen) {
                    if (!isOpen) {
                        setCurrentCaseId(null);
                    }
                }
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var schedule = (ScheduledCases);


/***/ }),

/***/ 91040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KC": function() { return /* binding */ isSameDay; },
/* harmony export */   "rh": function() { return /* binding */ getNextMonthDate; },
/* harmony export */   "u4": function() { return /* binding */ durationShort; }
/* harmony export */ });
/* unused harmony exports duration, isPastDate, getMonthName, getYear */

var getNextMonthDate = function() {
    var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date();
    var currentMonth = d.getMonth();
    var currentYear = d.getFullYear();
    var isLastYearMonth = currentMonth == 11;
    return isLastYearMonth ? new Date(currentYear + 1, 0, 1) : new Date(currentYear, currentMonth + 1, 1);
};
var duration = function(seconds) {
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds - hours * 60 * 60) / 60);
    return formatDuration({
        hours: hours,
        minutes: minutes
    });
};
var durationShort = function(seconds) {
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds - hours * 60 * 60) / 60);
    var parts = [];
    if (hours) {
        parts.push("".concat(hours, "h"));
    }
    if (minutes) {
        parts.push("".concat(minutes, "m"));
    }
    return parts.join(" ");
};
var isSameDay = function(first, second) {
    return first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
};
var isPastDate = function(date) {
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    return date < now;
};
var getMonthName = function() {
    var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date();
    return format(d, "LLLL");
};
var getYear = function() {
    var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date();
    return dateFnsGetYear(d);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6908,4690,6039,9774,2888,179], function() { return __webpack_exec__(72697); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);